// extracted by css-extract-rspack-plugin
export default {"commentEditor":"owEQw"};